import { Leader, Role, User, UsersTechnology } from '../types'
import { Row } from '../types/utils/DataTableUtils'

export const extractUserData = (row: Row): User => {
  const {
    id,
    firstName,
    lastName,
    email,
    phoneNumber,
    birthDate,
    createdAt,
    student,
    modifiedAt,
    employeeStatus,
    version,
    avatar,
    extension,
    vacationDays,
    employmentPercentage,
    employmentType,
    paidVacation,
    latestContract,
  } = row

  return {
    id,
    firstName,
    lastName,
    email,
    phoneNumber,
    birthDate,
    createdAt,
    student,
    leaders: [] as Leader[],
    modifiedAt,
    employeeStatus,
    technologies: [] as UsersTechnology[],
    roles: [] as Role[],
    version,
    avatar,
    extension,
    vacationDays,
    employmentPercentage,
    employmentType,
    paidVacation,
    latestContract,
  }
}

export const splitName = (fullName: string): { firstName: string; lastName: string } => {
  const parts = fullName.trim().split(' ')

  let firstName = ''
  let lastName = ''

  if (parts.length === 1) {
    firstName = parts[0]
  } else {
    lastName = parts.pop() || ''
    firstName = parts.join(' ')
  }

  return { firstName, lastName }
}
